import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DataTable from "../../components/data-table";
import { fetchDstExtraRules } from "../../actions/dst-extra-rules";
import { MONTH_NAMES } from "../../constants/month-names";

const COLUMNS = [
  { id: "id", label: "ID", link: true },
  { id: "year", label: "Year" },
  { id: "start_month", label: "Start Month" },
  { id: "start_day", label: "Start Day" },
  { id: "end_month", label: "End Month" },
  { id: "end_day", label: "End Day" },
  { id: "country.name", label: "Country" },
];

const parseDstRegion = (rule) => {
  const monthStart = MONTH_NAMES[rule.start_month];
  const monthEnd = MONTH_NAMES[rule.end_month];

  return { ...rule, start_month: monthStart, end_month: monthEnd };
};

const DstExtraRules = (props) => {
  const { getDstExtraRules, dstExtraRules } = props;

  const [parsedDstExtraRulesData, setParsedDstExtraRulesData] = useState([]);

  useEffect(
    () => {
      if (dstExtraRules.length) {
        setParsedDstExtraRulesData(dstExtraRules.map(parseDstRegion));
      }
    },
    [dstExtraRules],
  );

  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>DST Extra Rules</Col>
                <Col lg={8} style={{ textAlign: "right" }}>
                  <Button
                    href="/#/dst-extra-rules/new"
                    color="success"
                    size="sm"
                  >
                    New
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="parsedDstExtraRulesData"
                dataSource={getDstExtraRules}
                columns={COLUMNS}
                urlSchema="dst-extra-rules"
                {...props}
                parsedDstExtraRulesData={parsedDstExtraRulesData}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

DstExtraRules.propTypes = {
  getDstExtraRules: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dstExtraRules: PropTypes.arrayOf(PropTypes.object),
};

DstExtraRules.defaultProps = {
  dstExtraRules: [],
};

const mapStateToProps = ({ dstExtraRules }) => ({
  loading: dstExtraRules.loading,
  dstExtraRules: dstExtraRules.items,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDstExtraRules: (sort) => fetchDstExtraRules(sort),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstExtraRules);
